import { call, put, select } from 'redux-saga/effects';
import { Action } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { addActionNotification } from 'features/notifications/action-notifications/addActionNotification';
import { signalingAnswerEdited } from 'features/qa/actions';
import { selectAnswerById, selectQuestionById } from 'features/qa/qaSlice';
import { Answer, Question } from 'features/qa/types';
import { selectSidePanel, sidePanelOpened } from 'features/side-panels/sidePanelsSlice';
import { SidePanelType } from 'features/side-panels/types';
import { FeatureFlag } from 'features/feature-set/types';

export function* onAnswerEditedSaga(action: ReturnType<typeof signalingAnswerEdited>) {
  const { id, editedBy, answer: message, questionId, localEdit } = action.payload;

  const question: Question = yield select(selectQuestionById, questionId);
  const answer: Answer = yield select(selectAnswerById, id);

  if (!localEdit && answer.local) {
    const activePanel: SidePanelType = yield select(selectSidePanel);

    const actionNotificationThunk: Action = yield call(
      addActionNotification,
      {
        content: i18n.t(`notifications:qa.local_answer_edited.content`, {
          username: editedBy.name,
          answer: message,
        }),
        okText: i18n.t(`notifications:qa.local_answer_edited.btn_ok_label`),
        okAction: sidePanelOpened('qa', {
          questionId: question.id,
        }),
        hideOkAction: activePanel === 'qa',
        initiatorId: editedBy.id,
        scope: [FeatureFlag.qa],
        data: {
          questionId: question.id,
        },
      },
      {
        toastId: `${questionId}_${id}_${editedBy.id}`,
      }
    );

    yield put(actionNotificationThunk);
  }
}
